import React, { Component } from 'react';
import { Form, RadioGroup } from 'react-form';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {
    Input,
    Location,
    PhoneNumber,
    Select,
    CheckBox,
    RadioButton,
} from '../Form';
import Popup, { PopupTypes } from './PopupV2';
import config from '../../../config';

import { createReactFormValidator, required, optionalEmail } from '../../utils/validation';
import { intlPhoneNumber } from '../../utils/validation-libdep';
import SimpleRadio from '../Form/SimpleRadio';

import styles from './form.scss';
import { NewUserOnboardingIDs } from '../Analytics/testIDConfig';

class AdditionalInfoForm extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
        this.enableContinue = this.enableContinue.bind(this);
        this.validateLocation = this.validateLocation.bind(this);
    }

    enableContinue() {
        let enableContinue = false;

        if (this.props.isLocationChosenFromDropdown) {
            enableContinue = true;
        }

        return enableContinue;
    }

    validateLocation() {
        if (!this.props.isLocationChosenFromDropdown) {
            return 'Please enter a valid location';
        }
    }

    render() {
        const {
            months,
            days,
            onSubmit,
            onFormChange,
            submitting,
            flow,
            requiredOnboardingFlowType,
            exposeFormApi,
            handleLowAgeCheck,
            error,
            belowAgeAccpted,
            belowAge,
            popUpType,
            showPopup,
            togglePopup,
            handleAutocomplete,
            handleLocationChange,
            handleMonthChange,
            VintagePlayerForm,
            inputProps,
            isJuniorPlayer,
            defaultValues = {},
            defaultPhoneCountryCode = 'US',
            hideLabels = !themeV3,
            additionalDisplayFields = [],
            themeV3,
        } = this.props;
        let years = Array.from(new Array(moment().year() - 1899), (x, i) => i + 1900);
        years = years.sort((a, b) => b - a);
        const dayValues = Array.from(new Array(days), (x, i) => i + 1);
        const flowIsClubCreate = (flow === 'tournament_club_create' || flow === 'club_create' || flow === 'high_school_club_create');

        return (
            <div>
                <Form
                    onSubmit={values => onSubmit({ ...values, segment: flowIsClubCreate ? 'club_organizer' : 'player' })}
                    onChange={formApi => onFormChange({ ...formApi.values, segment: flowIsClubCreate ? 'club_organizer' : 'player' })}
                    defaultValues={defaultValues}
                >
                    {(formApi) => {
                        const { submitForm, values, touched, getWarning, getError } = formApi;
                        const genderTouched = touched.gender;
                        const genderError = getError('gender');
                        const genderWarning = getWarning('gender');
                        exposeFormApi(formApi);
                        return (
                            <form onSubmit={submitForm}>
                                {additionalDisplayFields.map((additionalField) => (
                                    <div className={`row`} key={`additional-field-${additionalField.field}`}>
                                        <div className="col-12">
                                            <Input
                                                id={`${additionalField.field}Input`}
                                                field={additionalField.field}
                                                placeholder={additionalField.placeholder}
                                                label={additionalField.label}
                                                hiddenLabel={hideLabels}
                                                disabled
                                                themeV3={themeV3}
                                                data-testid={additionalField.testid}
                                            />
                                        </div>
                                    </div>
                                ))}
                                <div className={`row`}>
                                    <div className="col-12">
                                        <label className={'fw500 fs16 mb8'}>
                                            Please fill out the following:
                                        </label>
                                        <label className={'mb24'}>
                                            If you are the player&apos;s parent/guardian and creating this account for them, please use their player {` `}
                                            <span className="dib">details.{` `}
                                                <a
                                                    data-testid={`${NewUserOnboardingIDs.PlayerDetailsInfoButton.component}-${NewUserOnboardingIDs.PlayerDetailsInfoButton.location}-${NewUserOnboardingIDs.PlayerDetailsInfoButton.id}`}
                                                    className="link clickable"
                                                    onClick={(ev) => { togglePopup(ev, PopupTypes.PLAYER_DETAILS); }}
                                                >
                                                    <img src="/img/v4/info-icon.svg" width={12} />
                                                </a>
                                            </span>
                                        </label>
                                        <Input
                                            id={`firstNameInput`}
                                            field={`firstName`}
                                            placeholder={!themeV3 && 'First name'}
                                            validate={createReactFormValidator(required)}
                                            label="First name"
                                            hiddenLabel={hideLabels}
                                            themeV3={themeV3}
                                            data-testid={`${NewUserOnboardingIDs.PIFirstNameInput.component}-${NewUserOnboardingIDs.PIFirstNameInput.location}-${NewUserOnboardingIDs.PIFirstNameInput.id}`}
                                        />
                                    </div>
                                </div>
                                <div className={`row`}>
                                    <div className="col-12">
                                        <Input
                                            id="lastNameInput"
                                            field="lastName"
                                            validate={createReactFormValidator(required)}
                                            placeholder={!themeV3 && 'Last name'}
                                            label="Last name"
                                            hiddenLabel={hideLabels}
                                            themeV3={themeV3}
                                            data-testid={`${NewUserOnboardingIDs.PILastNameInput.component}-${NewUserOnboardingIDs.PILastNameInput.location}-${NewUserOnboardingIDs.PILastNameInput.id}`}
                                        />
                                    </div>
                                </div>

                                {!VintagePlayerForm && (
                                    <>
                                        <div className={`row`}>
                                            <div className="col-12">
                                                <Location
                                                    label="Location (zip or city)"
                                                    placeholder={!themeV3 && `Location (zip or city)`}
                                                    id="location"
                                                    field={`location`}
                                                    inputProps={inputProps}
                                                    hiddenLabel={hideLabels}
                                                    searchOptions={{ types: ['(regions)'] }}
                                                    handleSelect={handleAutocomplete}
                                                    handleChange={handleLocationChange}
                                                    validate={this.validateLocation}
                                                    themeV3={themeV3}
                                                    data-testid={`${NewUserOnboardingIDs.PILocationInput.component}-${NewUserOnboardingIDs.PILocationInput.location}-${NewUserOnboardingIDs.PILocationInput.id}`}
                                                />
                                            </div>
                                        </div>
                                        <div className={`row`}>
                                            <div className="col-12">
                                                <PhoneNumber
                                                    label="Phone Number"
                                                    id="phone"
                                                    field="phone"
                                                    placeholder={!themeV3 && 'Mobile Phone'}
                                                    validate={createReactFormValidator([required, intlPhoneNumber])}
                                                    hiddenLabel={hideLabels}
                                                    defaultCountry={defaultPhoneCountryCode}
                                                    themeV3={themeV3}
                                                    data-testid={`${NewUserOnboardingIDs.PIPhoneInput.component}-${NewUserOnboardingIDs.PIPhoneInput.location}-${NewUserOnboardingIDs.PIPhoneInput.id}`}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div className={`form-group ${styles.radioGroup} row ${(genderTouched && genderError) && 'is-invalid'}`}>
                                    <div className="col-12">
                                        <RadioGroup
                                            field="gender"
                                            validate={createReactFormValidator(required)}
                                        >
                                            <div className="row">
                                                <div className="col-12">
                                                    <label className={'mb8 fw500'}>
                                                        Gender
                                                    </label>
                                                    {themeV3 && (
                                                        <>
                                                            <SimpleRadio
                                                                option={{ value: 'M', label: 'Male' }}
                                                                field={'gender'}
                                                                value={values.gender}
                                                                data-testid={`${NewUserOnboardingIDs.PIGenderMaleV3Input.component}-${NewUserOnboardingIDs.PIGenderMaleV3Input.location}-${NewUserOnboardingIDs.PIGenderMaleV3Input.id}`}
                                                            />
                                                            <SimpleRadio
                                                                option={{ value: 'F', label: 'Female' }}
                                                                field={'gender'}
                                                                value={values.gender}
                                                                data-testid={`${NewUserOnboardingIDs.PIGenderFemaleV3Input.component}-${NewUserOnboardingIDs.PIGenderFemaleV3Input.location}-${NewUserOnboardingIDs.PIGenderFemaleV3Input.id}`}
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                                {!themeV3 && (
                                                    <>
                                                        <div className="col-6">
                                                            <RadioButton
                                                                label={'Male'}
                                                                value={'M'}
                                                                id="male"
                                                                data-testid={`${NewUserOnboardingIDs.PIGenderMaleInput.component}-${NewUserOnboardingIDs.PIGenderMaleInput.location}-${NewUserOnboardingIDs.PIGenderMaleInput.id}`}
                                                            />
                                                            <div className={`${(genderTouched && genderError) && 'error-indicator'}`} />
                                                        </div>
                                                        <div className="col-6">
                                                            <RadioButton
                                                                label={'Female'}
                                                                value={'F'}
                                                                id="female"
                                                                data-testid={`${NewUserOnboardingIDs.PIGenderMaleInput.component}-${NewUserOnboardingIDs.PIGenderMaleInput.location}-${NewUserOnboardingIDs.PIGenderMaleInput.id}`}
                                                            />
                                                            <div className={`${(genderTouched && genderError) && 'error-indicator'}`} />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </RadioGroup>
                                        {genderTouched &&
                                            ((genderError && <div className="invalid-feedback">{genderError}</div>) ||
                                                (genderWarning && <div className="warning-feedback">{genderWarning}</div>))}
                                    </div>
                                </div>
                                <div className={`row`}>
                                    <div className="col-12">
                                        <div className="mb16">
                                            <label className="fw500" data-testid="nuo.additional-info.dob-label">
                                                Date of Birth {` `}
                                                <a
                                                    data-testid={`${NewUserOnboardingIDs.DateOfBirthInfoButton.component}-${NewUserOnboardingIDs.DateOfBirthInfoButton.location}-${NewUserOnboardingIDs.DateOfBirthInfoButton.id}`}
                                                    className="link clickable"
                                                    onClick={(ev) => { togglePopup(ev, PopupTypes.DATE_OF_BIRTH); }}
                                                >
                                                    <img src="/img/v4/info-icon.svg" width={12} />
                                                </a>
                                            </label>
                                            <br />
                                            <small className="fs12">Please enter the player&apos;s date of birth.
                                            </small>
                                        </div>
                                        <div className="row">
                                            <div className="col-5 col-md-6">
                                                <Select
                                                    id="month"
                                                    field="month"
                                                    options={months}
                                                    validate={createReactFormValidator(required)}
                                                    optionsAsPrimitiveArray={true}
                                                    hiddenLabel={hideLabels}
                                                    onChange={(val) => handleMonthChange(val)}
                                                    themeV3={themeV3}
                                                    label={themeV3 && 'Month'}
                                                    data-testid={`${NewUserOnboardingIDs.PIBirthdayMonthInput.component}-${NewUserOnboardingIDs.PIBirthdayMonthInput.location}-${NewUserOnboardingIDs.PIBirthdayMonthInput.id}`}
                                                />
                                            </div>
                                            <div className="col-3 col-md-3">
                                                <Select
                                                    id="day"
                                                    field="day"
                                                    options={dayValues}
                                                    validate={createReactFormValidator(required)}
                                                    optionsAsPrimitiveArray={true}
                                                    hiddenLabel={hideLabels}
                                                    themeV3={themeV3}
                                                    label={themeV3 && 'Day'}
                                                    data-testid={`${NewUserOnboardingIDs.PIBirthdayDayInput.component}-${NewUserOnboardingIDs.PIBirthdayDayInput.location}-${NewUserOnboardingIDs.PIBirthdayDayInput.id}`}
                                                />
                                            </div>
                                            <div className="col-4 col-md-3">
                                                <Select
                                                    id="year"
                                                    field="year"
                                                    options={years}
                                                    validate={createReactFormValidator(required)}
                                                    isArray={true}
                                                    hiddenLabel={hideLabels}
                                                    optionsAsPrimitiveArray={true}
                                                    // emptyOption="Year"
                                                    themeV3={themeV3}
                                                    label={themeV3 && 'Year'}
                                                    data-testid={`${NewUserOnboardingIDs.PIBirthdayYearInput.component}-${NewUserOnboardingIDs.PIBirthdayYearInput.location}-${NewUserOnboardingIDs.PIBirthdayYearInput.id}`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.text}>
                                    <a
                                        data-testid={`${NewUserOnboardingIDs.PIWhyBirthday.component}-${NewUserOnboardingIDs.PIWhyBirthday.location}-${NewUserOnboardingIDs.PIWhyBirthday.id}`}
                                        onClick={(ev) => { togglePopup(ev, flowIsClubCreate ? PopupTypes.BIRTHDAY_CLUB : PopupTypes.BIRTHDAY); }}
                                    >
                                        Why do I need to provide my birthday?
                                    </a>
                                </div>
                                {!flowIsClubCreate && requiredOnboardingFlowType !== 'NoProfileMember' && (
                                    <div className={`fs12 mt24`} data-testid="nuo.additional-info.parent-signup-text">
                                        Are you a parent signing up for a child?&nbsp;
                                        <a
                                            data-testid={`${NewUserOnboardingIDs.PIParent.component}-${NewUserOnboardingIDs.PIParent.location}-${NewUserOnboardingIDs.PIParent.id}`}
                                            className="link clickable"
                                            onClick={(ev) => { togglePopup(ev, PopupTypes.PARENTS); }}
                                        >
                                            Click here.
                                        </a>
                                    </div>
                                )}
                                {(belowAge && !flowIsClubCreate) && (
                                    <>
                                        <div className="fs12 mt24">
                                            By registering for UTR Sports, you agree to our&nbsp;
                                            <Link
                                                data-testid={`${NewUserOnboardingIDs.PITerms.component}-${NewUserOnboardingIDs.PITerms.location}-${NewUserOnboardingIDs.PITerms.id}`}
                                                to={{ pathname: `${config.marketingAppHost}/tos` }}
                                                target="_blank"
                                            >Terms of Service
                                            </Link> and&nbsp;
                                            <Link
                                                data-testid={`${NewUserOnboardingIDs.PIPrivacy.component}-${NewUserOnboardingIDs.PIPrivacy.location}-${NewUserOnboardingIDs.PIPrivacy.id}`}
                                                to={{ pathname: `${config.marketingAppHost}/privacy` }}
                                                target="_blank"
                                            >Privacy Policy
                                            </Link>. If you are a parent entering personally identifiable information for players under age 13, you confirm that you are responsible for managing the profile. As a reminder, we do not permit children under 13 to register with UTR Sports or provide us with any personal information.
                                        </div>
                                        <CheckBox
                                            id="belowAgeCheckbox"
                                            field="belowAgeCheckbox"
                                            customLabel={<span className={'text-medium text-weight-normal'}>I agree</span>}
                                            formGroupCssClass="mt16 mb8"
                                            onChange={handleLowAgeCheck}
                                            defaultChecked={belowAgeAccpted}
                                            data-testid={`${NewUserOnboardingIDs.PIAgree.component}-${NewUserOnboardingIDs.PIAgree.location}-${NewUserOnboardingIDs.PIAgree.id}`}
                                        />
                                    </>
                                )}
                                {(isJuniorPlayer && !flowIsClubCreate) && (
                                    <div className={`row`}>
                                        <div className="col-12 mt24">
                                            <Input
                                                label="Message Copy"
                                                id="secondaryEmail"
                                                field="secondaryEmail"
                                                type="text"
                                                description="An additional email address that will receive copies of the messages you receive on the UTR Sports platform."
                                                placeholder="Email address"
                                                validate={optionalEmail}
                                                disableProfanityCheck={true}
                                                themeV3={themeV3}
                                                data-testid={`${NewUserOnboardingIDs.PISecondaryEmail.component}-${NewUserOnboardingIDs.PISecondaryEmail.location}-${NewUserOnboardingIDs.PISecondaryEmail.id}`}
                                            />
                                        </div>
                                    </div>
                                )}
                                {error && (
                                    <div><span className="error-text">{error}</span></div>
                                )}
                                <>
                                    <div className="row">
                                        <div className="form-group col-12 mb0">
                                            <button
                                                type="submit"
                                                className={`btn btn-primary btn-xl btn-block ${styles.btn} mt24`}
                                                disabled={submitting || !this.enableContinue(values)}
                                                data-testid={`${NewUserOnboardingIDs.PIContinueSubmit.component}-${NewUserOnboardingIDs.PIContinueSubmit.location}-${NewUserOnboardingIDs.PIContinueSubmit.id}`}
                                            >
                                                CONTINUE
                                            </button>
                                        </div>
                                    </div>
                                </>
                                {showPopup
                                    ? (
                                        <Popup
                                            popUpType={popUpType}
                                            closePopup={togglePopup}
                                        />
                                    )
                                    : null}
                            </form>
                        );
                    }}
                </Form>
            </div>
        );
    }
}

export default AdditionalInfoForm;
